import { useMemo } from 'react';
import isNil from 'lodash/isNil';
import { IFieldFieldsFragment } from '../../utils/apollo/graphqlSchema';
import { MaybeNil } from '../../utils/interfaces';
import { IParentFieldValueFilter } from './types';

export const useParentFieldValueFilter = (
  variantField: IFieldFieldsFragment,
  experimentField: IFieldFieldsFragment,
  experimentId: string | null,
): IParentFieldValueFilter[] =>
  // memoizing because it is used in useMemo in the components that use it
  useMemo(() => {
    if (
      variantField.pfv?.valueParent?.key === experimentField.key &&
      !isNil(experimentId)
    ) {
      return [{ field: experimentField, value: experimentId }];
    } else {
      return [];
    }
  }, [experimentField, experimentId, variantField.pfv?.valueParent?.key]);

export const getParentFieldValueTooltip = (
  pfvFilter: MaybeNil<IParentFieldValueFilter[]>,
) => {
  if (isNil(pfvFilter) || pfvFilter.length === 0) {
    return undefined;
  }

  const value = pfvFilter
    .map(({ field: { name }, value }) => `${name}: ${value}`)
    .join(', ');

  return `Filtered by ${value}`;
};
